import axios from "./axios-handler.service";
import { Produto } from "./produtos.service";
const BASE_URL_KIT = "/api/KitsDinamicos";

export interface KitDinamico {
  idKitDinamico?: string;
  descricao?: string;
  codigoFornecedor?: string;
  validoApos?: string;
  validoAte?: string;
  aplicaDesconto?: boolean;
  dataCriacao?: string;
  dataAlteracao?: string;
  excluido?: boolean;
  preco?: number;
  items?: ItemKitDinamico[];
}

export interface ItemKitDinamico {
  kitDinamico?: KitDinamico;
  idItemKitDinamico?: string;
  sequencia?: number;
  descricao?: string;
  valor?: number;
  produtos?: Produto[];
}

export interface IncluirItemKitDinamicoCommand {
  idKitDinamico: string;
  descricao: string;
}

export interface AlterarItemKitDinamicoCommand {
  idItemKitDinamico: string;
  descricao: string;
}

export interface OrdernarItemKitDinamicoCommand {
  idKitDinamico: string;
  idItemKitDinamico: string;
  step: number;
}

export interface AssociarProdutoItemKitDinamicoCommand {
  idKitDinamico: string;
  idItemKitDinamico: string;
  produtos: (string | undefined)[];
}

export interface FiltroKitsDinamicos {
  txtPesquisa: string;
  offset: number;
  limit: number;
  order?: string;
}

export class KitsDinamicosService {
  static async listarKitsDinamicos(filtro: FiltroKitsDinamicos): Promise<KitDinamico[]> {
    const {txtPesquisa, offset, limit, order} = filtro;
    const response = await axios.get<KitDinamico[]>(`${BASE_URL_KIT}/ListarKitsDinamicos`, {
      params: { 
        txtPesquisa, 
        offset, 
        limit, 
        order 
      },
    });
    return response.data;
  }

  static async manterKitDinamico(kitDinamico: KitDinamico) {
    const res = await axios.post<string>(
      BASE_URL_KIT + "/ManterKitDinamico",
      kitDinamico
    );
    return res.data;
  }

  static async incluirItemKitDinamico(
    command: IncluirItemKitDinamicoCommand
  ): Promise<string> {
    const res = await axios.post<string>(
      BASE_URL_KIT + "/IncluirItemKitDinamico",
      command
    );
    return res.data;
  }

  static async alterarItemKitDinamico(
    command: AlterarItemKitDinamicoCommand
  ): Promise<void> {
    await axios.post(BASE_URL_KIT + "/AlterarItemKitDinamico", command);
  }

  static async ordenarItemKitDinamico(
    command: OrdernarItemKitDinamicoCommand
  ): Promise<void> {
    await axios.post(BASE_URL_KIT + "/OrdenarItemKitDinamico", command);
  }

  static async deletarItemKitDinamico(
    idItemKitDinamico: string
  ): Promise<void> {
    await axios.post(BASE_URL_KIT + "/DeletarItemKitDinamico/", {
      idItemKitDinamico,
    });
  }

  static async obterKitDinamico(id: string): Promise<KitDinamico> {
    const response = await axios.get<KitDinamico>(
      `${BASE_URL_KIT}/ObterKitDinamico`,
      {
        params: { id },
      }
    );
    return response.data;
  }

  static async listarProdutosKitsDinamicos(
    txtPesquisa: string
  ): Promise<Produto[]> {
    const response = await axios.get<Produto[]>(
      `${BASE_URL_KIT}/ListarProdutos`,
      {
        params: { txtPesquisa },
      }
    );
    return response.data;
  }

  static async associarProdutos(
    command: AssociarProdutoItemKitDinamicoCommand
  ) {
    await axios.post(`${BASE_URL_KIT}/AssociarProduto`, command);
  }
}
